<!--
  - ===========================================================================
  - [StrongGate Limited] [http://www.stronggate.com]
  - Copyright (c) 2023-2024. All rights Reserved.
  - Unauthorized access, use, dissemination, distribution, reproduction of this
  - file, or a portion of, in any form is prohibited and unlawful. If you receive
  - this file, and you are not an authorized company employee, or you believe you
  - have received this file in error, please notify the sender (or originator)
  - and promptly delete this file.
  -
  - Project:
  - File: ztn-cancel-button.vue
  - Created by: ChanYing
  - Create Date: 2024-03-12 18:07
  - Version Number: 1.0
  - Version Description:
  -
  - =============================================================================
  -->

<template>
  <button class="ztn-cancel-button" type="button" :id="id" :disabled="loading || disabled" :class="{'ztn-cancel-button--disabled':disabled || loading}">
    <img src="@/assets/images/icon-png/arrow-left-thick.svg" v-show="leftIcon" alt="" class="ztn-cancel-button__icon"/>
    <img src="@/assets/images/icon-png/plus-outline-circle.svg" v-show="circleIcon" alt="" class="ztn-cancel-button__icon"/>
    &nbsp;<span class="ztn-page-t400 ztn-cancel-button__text">{{ buttonText }}</span>
  </button>
</template>

<script>
export default {
  name: "ztn-cancel-button",
  props: {
    leftIcon: Boolean,
    circleIcon: Boolean,
    buttonText: String,
    disabled: Boolean,
    loading: Boolean,
    id: String
  }
}
</script>

<style scoped>
.ztn-cancel-button {
  position: relative;
  height: var(--control-height-sm);
  box-sizing: border-box;
  align-items: center;
  background: var(--base-bg-primary-8);
  border-radius: var(--radius-sm);
  border: none;
  padding-right: var(--space-3);
  margin-right: var(--space-3);
  color: var(--body-color-1);
}

.ztn-cancel-button__icon {
  width: var(--icon-size-sm);
  height: var(--icon-size-sm);
}

.ztn-cancel-button:hover:not(:disabled) {
  box-sizing: border-box;
  align-items: center;
  border: 1px solid var(--base-bg-primary-7);
  background: var(--base-bg-primary-7);
  cursor: pointer;
}

.ztn-cancel-button:disabled,
.ztn-cancel-button--disabled {
  background: transparent !important;
  border: none !important;
  color: var(--on-surface);
  cursor: not-allowed;
}

.ztn-cancel-button:disabled::before,
.ztn-cancel-button--disabled::before {
  content: '';
  position: absolute;
  inset: 0;
  border-radius: inherit;
  background: var(--on-surface);
  opacity: var(--state-disabled-container-opacity);
  pointer-events: none;
}

.ztn-cancel-button:disabled img,
.ztn-cancel-button:disabled .ztn-cancel-button__text,
.ztn-cancel-button--disabled img,
.ztn-cancel-button--disabled .ztn-cancel-button__text {
  position: relative;
  z-index: 1;
  opacity: var(--state-disabled-content-opacity);
  color: inherit;
}

.ztn-cancel-button__text {
  vertical-align: middle;
  color: inherit;
}
</style>